import { useEffect, useState } from "react";
import { AnswerSize } from "../../../enums/answer-size.enum";
import { AnswerType } from "../../../enums/answer-type.enum";
import { Answer } from "../../questions/answer/answer";
import styles from "./form-field.module.scss";
import { IAnswer } from "../../../interfaces/answer.interface";

interface FormFieldProps {
  name: string;
  value: string | any[];
  onChange: (element: HTMLInputElement & EventTarget | { name: string, value: any }) => void;
  label?: string;
  defaultValue?: any;
  answers: Array<{
    id: number;
    value: any;
    reset?: boolean;
    checked?: boolean;
  }>
}

function mutuallyExclusive(answ1: { reset: boolean }, answ2: { reset?: boolean }) {
  return (answ1.reset && !answ2.reset) || (!answ1.reset && answ2.reset);
}

export function FormFieldVariants(props: FormFieldProps) {
  const { answers, name, value, onChange, defaultValue } = props;
  const [answersDupl, setAnswersDupl] = useState([...answers]);

  useEffect(() => {
    setAnswersDupl([...answers]);
  }, [answers]);

  useEffect(() => {
    if (value instanceof Array) {
      setAnswersDupl(oldState => {
        return oldState.map(answer => {
          return value.includes(answer.value) ? { ...answer, checked: true } : { ...answer, checked: false };
        });
      });
    } else {
      setAnswersDupl(oldState => {
        return oldState.map(answer => {
          return value == answer.value ? { ...answer, checked: true } : { ...answer, checked: false };
        });
      });
    }
  }, [value]);

  const changeHandler = (value: any, checked: boolean, checkedAnswer: IAnswer) => {
    const updatedAnswers = answersDupl.map(answer => {
      if (answer.value == value) return { ...answer, checked };

      if (((checked && mutuallyExclusive({ reset: checkedAnswer.reset }, answer)) || answer.checked)) {
        return { ...answer, checked: false };
      }

      return answer;
    });

    setAnswersDupl(updatedAnswers);
    onChange && onChange({ name: name, value: value });
  }

  return (<div className={styles.variantsField}>
    {answersDupl.map((answer, i) => {
      return <Answer
        answer={{ ...answer, size: AnswerSize.FULL, type: AnswerType.PLAIN }}
        key={answer.id}
        onChange={changeHandler}
        name={name}
        active={true}
        mode="phone-form"
        anyAnswerChecked={Boolean(answersDupl.find(el => el.checked))}
        defaultChecked={answer.value == defaultValue}
      />
    })}
  </div>)
}